jQuery(function ($) {

    if ( $('.faq__question').length ) {
        $('.faq__question').on('click', function(e) {
            if ( $(this).hasClass('is-open') ) {
                $(this).next().css('height', '0');

                $(this).removeClass('is-open');
                $(this).addClass('is-close');
            }else{
                $(this).next().css('height', $(this).next().find('.faq__answer').innerHeight() );

                $(this).removeClass('is-close');
                $(this).addClass('is-open');
            }
        });
    }

});